import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import _ from 'lodash';

import DepartmentPage from '../components/company/department-page';
import NotFound from '../components/company/not-found';

const DepartmentRoute = ({ department, blogs, match, errors }) => {
  const slug = _.get(match, 'params.slug', '');

  if ((slug !== '' && slug.split(' ').length > 1) || /[A-Z]/.test(slug)) {
    const newSlug = _.kebabCase(slug);
    return <Redirect to={`/careers/${newSlug}`} />;
  }

  if (!_.get(department, 'name') || errors.length !== 0) {
    return (
      <Fragment>
        <DocumentTitle title="Not Found | NerdWallet" />
        <NotFound errorType="department" />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <DocumentTitle title={`${_.get(department, 'name', '')} | NerdWallet`} />
      <DepartmentPage
        department={department}
        blogPosts={_.get(
          blogs,
          [_.get(department, 'slug', ''), 'blogPosts'],
          []
        )}
      />
    </Fragment>
  );
};

DepartmentRoute.displayName = 'Department Route';
DepartmentRoute.analyticsName = 'department_page';

DepartmentRoute.propTypes = {
  department: PropTypes.object.isRequired,
  blogs: PropTypes.object,
  match: PropTypes.object,
  errors: PropTypes.object,
};

export default connect((state) => ({
  department: state.careersData.department,
  blogs: state.careersData.blogs,
  errors: state.errors,
}))(DepartmentRoute);
